import {
  Box,
  Modal,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import IconReusable from "../../../components/IconReusable";

/**
 * GlassDialog — a reusable, always-centered glass-background modal.
 *
 * Unlike `GlassModal` (which slides up from the bottom / goes full-width on
 * mobile), `GlassDialog` stays centered on every viewport and provides only the
 * glass card + a free `children` slot — the caller owns all content.
 */
const HumbeeGlassDialog = ({
  open,
  onClose,
  loading,
  width = { xs: 'auto', md: 600 },
  maxWidth = { xs: 'auto', md: 600 },
  zIndex = 1300,
  sx = {},
  showCloseIcon = false,
  children
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: zIndex,
      }}>
      <Box
        sx={{
          borderRadius: 2,
          textAlign: "center",
          width: width,
          maxWidth: maxWidth,
          p: 2,
          m: 0,
          gap: 4,
          backgroundColor: !isMobile ? "#ffffffd1" : "#ffffffd1",
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(5px)",
          // boxShadow: 24,
          display: "flex",
          flexDirection: "column",
          ...sx,
        }}>
        {showCloseIcon && onClose && (
          <Box
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              cursor: "pointer",
              zIndex: 1,
            }}>
            <IconReusable
              name="Close"
              onClick={onClose}
              color="#333"
              width="24px"
              height="24px"
            />
          </Box>
        )}
        {children}
      </Box>
    </Modal>
  );
};

export default HumbeeGlassDialog;
